import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, Sparkles } from "lucide-react";
import api from "@/lib/api";

export default function Alumni() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/titleholders").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const current = items.find((t) => t.is_current);
  const past = items.filter((t) => !t.is_current);

  return (
    <div className="section py-12 sm:py-16" data-testid="alumni-page">
      <p className="kicker mb-2">The Legacy Continues</p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl text-amber-50">Titleholders & Alumni</h1>
      <p className="mt-3 max-w-2xl text-amber-100/60">Every crown leaves a legacy. Meet the women who carry the vision of a united Africa forward.</p>

      {current && (
        <div className="mt-10" data-testid="current-titleholder">
          <p className="kicker mb-4 flex items-center gap-2"><Crown className="h-4 w-4 text-gold" /> Reigning Titleholder</p>
          <div className="glass grid gap-6 rounded-2xl p-6 sm:grid-cols-[220px_1fr] sm:p-8">
            <div className="card-lux aspect-[3/4] overflow-hidden">
              <img src={current.portrait_url} alt={current.name} className="h-full w-full object-cover object-top" />
            </div>
            <div>
              <span className="text-4xl">{current.flag}</span>
              <h2 className="mt-2 font-serif text-4xl gold-text">{current.name}</h2>
              <p className="text-amber-100/70">{current.delegation_name} · Reign {current.reign}</p>
              <p className="mt-4 text-amber-100/60">{current.impact}</p>
              {current.projects?.length > 0 && (
                <div className="mt-4"><p className="kicker mb-2">Signature Projects</p><ul className="space-y-1 text-sm text-amber-50/80">{current.projects.map((p, i) => <li key={i} className="flex items-center gap-2"><Sparkles className="h-3 w-3 text-gold" /> {p}</li>)}</ul></div>
              )}
              {current.appearances?.length > 0 && <p className="mt-4 text-xs text-muted-foreground">Appearances: {current.appearances.join(" · ")}</p>}
            </div>
          </div>
        </div>
      )}

      <p className="kicker mb-5 mt-14">Hall of Fame</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {past.map((t) => (
          <div key={t.id} className="card-lux overflow-hidden" data-testid={`titleholder-${t.year}`}>
            <div className="aspect-[3/4] overflow-hidden bg-obsidian-600"><img src={t.portrait_url} alt={t.name} loading="lazy" className="h-full w-full object-cover object-top" /></div>
            <div className="p-4">
              <p className="font-mono text-xs gold-text">{t.year}</p>
              <h3 className="font-serif text-lg text-amber-50">{t.name} {t.flag}</h3>
              <p className="text-xs text-muted-foreground">{t.delegation_name} · {t.advocacy}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
